<app-alerts />
<app-user-form (submitClickEvent)="handleSubmitClick($event)" />
